import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-opacity": ".7",
      d: "M19.174 21.565H4.827a2.394 2.394 0 0 1-2.391-2.392V4.826a2.394 2.394 0 0 1 2.39-2.391h14.348a2.394 2.394 0 0 1 2.392 2.39v14.348a2.394 2.394 0 0 1-2.392 2.392M4.827 4.028a.8.8 0 0 0-.798.798v14.347c0 .44.358.798.798.798h14.347c.44 0 .798-.358.798-.798V4.826a.8.8 0 0 0-.798-.798z",
      style: {"fill-opacity":".7"}
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.421 6.133h-1.993c-.66 0-1.196.535-1.196 1.195v9.167c0 .66.536 1.196 1.196 1.196h1.993c.66 0 1.196-.536 1.196-1.196V7.328c0-.66-.535-1.195-1.196-1.195",
      style: {"fill-opacity":"1"}
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.821 18.288h-2.789a1.397 1.397 0 0 1-1.395-1.395V6.929c0-.768.625-1.395 1.395-1.395h2.79c.768 0 1.395.626 1.395 1.395v9.964a1.4 1.4 0 0 1-1.396 1.395m-2.79-11.557a.2.2 0 0 0-.2.2v9.963c0 .11.09.2.2.2h2.79a.2.2 0 0 0 .199-.2V6.93a.2.2 0 0 0-.2-.2z",
      style: {"fill-opacity":"1"}
    }, null, -1)
  ])))
}
export default { render: render }